<template>
    <div class="myData">
        <trend ref="trend"></trend>
        <proportion ref="proportion" class="proportion"></proportion>
        <activity></activity>
    </div>
</template>

<script>
import bigData from '@/services/bigData'
import trend from './components/trend'
import activity from './components/activity'
import proportion from '../national/components/proportion'
export default {
    components: {
        trend, proportion, activity
    },
    created() {
        this.getDetails()
    },
    methods: {
        getDetails() {
            bigData.overall().then(res => {
                if (res.code == 0 ) {
                    this.$nextTick(() => {
                        this.$refs.trend.trendData = res.result;
                        this.$refs.proportion.set(res.result.dance)
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.myData{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 1500px;
    overflow-x: auto;
    height: 100%;
    background-color: #222236;
    padding: 24px;
    box-sizing: border-box;
    overflow-y: auto;
}
.proportion{
    width: 700px;
}
</style>
